import {AfterViewInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core'
import {ButtonComponent} from '../button/button.component'
import {
  simpleValueAccessorProvider,
  SimpleValueAccessorSupportComponent
} from '../../../util/angular/simple-value-accessor'

export interface ButtonModel {
  id?: number,
  label?: string,
  description?: string,
  name?: string,
  imageSource?: string
}

@Component({
  selector: 'shared-button-group',
  styleUrls: ['./button-group.component.scss'],
  templateUrl: './button-group.component.html',
  providers: [simpleValueAccessorProvider(ButtonGroupComponent)]
})
export class ButtonGroupComponent extends SimpleValueAccessorSupportComponent<ButtonModel> implements AfterViewInit {

  private isLoadedLocal = true

  @ContentChildren(ButtonComponent) nestedButtons!: QueryList<ButtonComponent>

  localButtons: ButtonModel[] =  []

  @Input()
  disabled = false

  get buttons(): ButtonModel[] {
    return this.localButtons
  }

  @Input()
  set buttons(buttons: ButtonModel[]) {
    if (buttons) {
      this.localButtons = [...buttons]
      this.localButtons.forEach((value, index) => {
        if (!value.id) {
          value.id = index + 1
        }
      })
    } else {
      this.localButtons = buttons
    }
  }

  @Output() buttonClick = new EventEmitter<ButtonModel>()

  buttonClicked(event: Event, buttonModel: ButtonModel): void {
    event.stopPropagation()
    if (this.disabled) {
      return;
    }
    this.value = buttonModel
    this.buttonClick.emit(this.value)
    this.onChange(this.value)
  }

  isActive(button: ButtonModel): boolean {
    return this.value ? button.id === this.value.id : false
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.nestedButtons && this.nestedButtons.length > 0) {

        this.buttons = []
        this.nestedButtons.forEach((button, index) => {
          this.buttons.push(
            {
              id: button.id ? button.id : index + 1,
              label: button.label,
              name: button.name,
              description: button.description,
              imageSource: button.imageSource
            })
        })
      }

      this.isLoadedLocal = false
    }, 0)
  }
}
